export default "__VITE_ASSET__BbkKFxPG__"